export default {
  // 获取短信发送地区列表
  GET_ADCDLIST: 'GET_ADCDLIST',
  // 获取责任人列表
  GET_PERSONLIST: 'GET_PERSONLIST',
  // 导出责任人管理-导出
  EXPORT_PERSONLIST: 'EXPORT_PERSONLIST',
  // 获取短信模板
  GET_MSGTEMP_LIST: 'GET_MSGTEMP_LIST',
  // 获取责任人信息行政区列表
  GET_NEXTADCDLIST: 'GET_NEXTADCDLIST',
  // 获取部门列表
  GET_DEPTLIST: 'GET_DEPTLIST',
  // 获取部门及行政区划列表
  GET_DEPT_ADCDLIST: 'GET_DEPT_ADCDLIST',
  // 获取群组列表
  GET_GROUPLIST: 'GET_GROUPLIST',
  // 保存责任人信息
  SAVE_PERSONINFO: 'SAVE_PERSONINFO',
  // 已发短信查询--获取数据
  GET_SEND_MESSAGE_QUERY: 'GET_SEND_MESSAGE_QUERY',
  // 预报预警查询--获取数据
  GET_PROXY_LIST_FORECAST_MESSAGE_DETAIL: 'GET_PROXY_LIST_FORECAST_MESSAGE_DETAIL',
  // 已发短信查询--查看内短消息数据
  GET_SENDMESSAGE_QUERY_LIABLEPERSON: 'GET_SENDMESSAGE_QUERY_LIABLEPERSON',
  // 删除责任人数据
  DELETE_PERSONINFOGROUP: 'DELETE_PERSONINFOGROUP',
  // 预警信息查看--获取数据
  GET_WARNRECORD_LIST: 'GET_WARNRECORD_LIST',
  // 预警信息查看--新建/保存
  SAVE_MESSAGE_TEMPLATE: 'SAVE_MESSAGE_TEMPLATE',
  // 预警信息查看--删除
  DELEDE_MESSAGE_TEMPLATE: 'DELEDE_MESSAGE_TEMPLATE',
  // 预警信息查看-导出
  WARN_INFOLIST_EXPORT: 'WARN_INFOLIST_EXPORT',
  // 短信模板
  GET_MESSAGE_TEMPLATELIST: 'GET_MESSAGE_TEMPLATELIST',
  // 获取群组保存信息
  GET_PERSONGROUPRELATION: 'GET_PERSONGROUPRELATION',
  // 保存群组信息
  SAVE_PERSONGROUPRELATION: 'SAVE_PERSONGROUPRELATION',
  // 短信发送
  SENG_MESSAGE: 'SENG_MESSAGE',
  // 获取自然村列表
  GET_NATURAL_VILLAGE_LIST: 'GET_NATURAL_VILLAGE_LIST',
  // 获取已配置群组信息
  GET_CONFIGURED_LIST: 'GET_CONFIGURED_LIST',
  // 保存群组配置信息
  SAVE_CONFIGURED_INFO: 'SAVE_CONFIGURED_INFO',
  // 预警信息
  GET_STATION_MAP: 'GET_STATION_MAP',
  GET_NEXT_ADCD_LIST: 'GET_NEXT_ADCD_LIST',
  SAVE_BASE_STATION_WARNIFNO: 'SAVE_BASE_STATION_WARNIFNO',
  GET_EARLY_WARNING_LIST: 'GET_EARLY_WARNING_LIST',
  GET_NEW_EARLY_WARNING: 'GET_NEW_EARLY_WARNING',
  CHANGE_WARNING_STATUS: 'CHANGE_WARNING_STATUS',
  ONE_CLICK_CONFIGURATION: 'ONE_CLICK_CONFIGURATION',
  // 行政区划信息编码搜索
  GET_BASE_STREET_LIST: 'GET_BASE_STREET_LIST',
  // 根据预警id获取人员
  person_order_warnid: 'person_order_warnid',
  // 导出责任人管理模板-下载
  EXPORT_TEMPLATE_PERSONLIST: 'EXPORT_TEMPLATE_PERSONLIST'
}
